import { featuredMovies } from '@/mocks/homeData';
import { useNavigate } from 'react-router-dom';

export default function FeaturedSection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              推荐电影 <span className="text-primary-500">精选</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">精心挑选的高分佳片，每一部都值得细细品味</p>
          </div>
          <button
            onClick={() => {
              navigate('/category/dongzuo');
              window.scrollTo({ top: 0, behavior: 'instant' });
            }}
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            更多推荐 <i className="ri-arrow-right-line"></i>
          </button>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {featuredMovies.map((movie) => (
            <article
              key={movie.id}
              onClick={() => {
                navigate(`/article/${movie.id}`);
                window.scrollTo({ top: 0, behavior: 'instant' });
              }}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl mb-3 aspect-[2/3]">
                <img
                  src={movie.image}
                  alt={`${movie.title} - ${movie.titleEn}`}
                  title={`${movie.title} ${movie.year}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-[11px] font-semibold">
                    {movie.quality}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="px-2 py-0.5 rounded-md bg-foreground-950/60 text-accent-400 text-[11px] font-semibold backdrop-blur-sm">
                    {movie.rating}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <button className="w-full py-2 rounded-lg bg-primary-500 text-background-50 text-xs font-semibold flex items-center justify-center gap-1 whitespace-nowrap">
                    <i className="ri-play-fill"></i> 立即播放
                  </button>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors truncate">
                {movie.title}
              </h3>
              <div className="flex items-center gap-2 mt-1">
                <span className="text-xs text-foreground-500">{movie.year}</span>
                <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
                <span className="text-xs text-foreground-500">{movie.category}</span>
              </div>
            </article>
          ))}
        </div>

        <div className="flex sm:hidden justify-center mt-6">
          <button
            onClick={() => {
              navigate('/category/dongzuo');
              window.scrollTo({ top: 0, behavior: 'instant' });
            }}
            className="px-6 py-2.5 rounded-full border border-primary-300 text-sm font-medium text-primary-500 hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            更多推荐
          </button>
        </div>
      </div>
    </section>
  );
}